import { useLazyQuery } from '@biletiniz/apollo';
import { useEffect, useState } from '@biletiniz/ui-core';
import { AIRLINES } from './gql';

const PAGE_SIZE = 20;

export const useAirlines = () => {
  const [getAirlines, { data, error, loading }] = useLazyQuery(AIRLINES, {
    fetchPolicy: `network-only`,
  });

  const [localData, setLocalData] = useState([]);

  useEffect(() => {
    getAirlines();
  }, []);

  useEffect(() => {
    if (data?.airlines) {
      setLocalData(data.airlines);
    }
  }, [data]);

  const getPaginatedData = (page = 1) => {
    const start = (page - 1) * PAGE_SIZE;
    const end = page * PAGE_SIZE;
    return localData.slice(start, end);
  };

  return {
    loading,
    error,
    total: localData.length,
    getPaginatedData,
    pageSize: PAGE_SIZE,
  };
};
